import { MethodsEnum } from "../enums/Methods.ts";
import handleService from "./apiService.ts";

const listarPlanos = async () => {
  const result = await handleService({
    method: MethodsEnum.GET,
    endpoint: "/plano",
  });
  return result;
};

const getPlano = async (planoId: string) => {
  const result = await handleService({
    method: MethodsEnum.GET,
    endpoint: `/plano/${planoId}`,
  });

  return result;
};

const obterLimitesPlano = async () => {
  const result = await handleService({
    method: MethodsEnum.GET,
    endpoint: "/plano/limites",
  });
  return result?.data || null;
};

const planosService = { listarPlanos, getPlano, obterLimitesPlano };
export default planosService;
